import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../store/app.service';
import { ILead } from '../../../core/models/lead.models';
import { TasksService } from '../../tasks/tasks.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ITask } from '../../../core/models/tasks.models';
import { NOTES_TYPE } from '../../../core/helpers/constants';
import { ClientsApiService } from '../clients.apiservice';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IClient } from '../../../core/models/clients.models';
import { IPermission } from '../../../core/models/auth.models';
import { TasksApiService } from '../../tasks/tasks.apiservice';
import { LeadsApiService } from '../../leads/leads.apiservice';
import { getRolesForPage } from '../../../core/helpers/utility';
import { ICampaign } from '../../../core/models/campaigns.model';
import { ReportsApiService } from '../../reports/reports.apiservice';
import { RefreshSignals } from '../../../layouts/sidebar/menu.model';
import { UtilityService } from '../../../core/helpers/utility.service';
import { IReportingConfig } from '../../../core/models/reporting.models';
import { CampaignsApiService } from '../../campaigns/campaigns.apiservice';
import { PAGE_NAMES, ROLES, ROLES_TYPE } from '../../../core/helpers/constants';
import { SubscriptionApiService } from '../../subscriptions/subscription.apiservice';
import { IColumn, LoadDataFromServer } from '../../../shared/components/datatable/datatable.model';
import { ClientReportingUpdateModalComponent } from '../client-reporting-update/client-reporting-update.component';
import { OrdersApiService } from '../../orders/orders.apiservice';
import { TagsApiService } from '../../../pages/tags/tags.apiservice';
import { DmsChangeFormComponent } from '../../forms/dms-change-form/dms-change-form.component';
import { TechRequestComponent } from '../../forms/tech-request/tech-request.component';
import { CreateTaskExternalModal } from '../../forms/create-task-external/create-task-external.component';
import { ITag } from '../../../core/models/tags.models';
import { CreativeRequestComponent } from '../../forms/creative-request/creative-request.component';
import { DataFeedService } from '../../../shared/api/datafeed.service';
import { InstanceService } from '../../../core/instance/instance.service';
import { ClientsService } from '../clients.service';
import { CampaignsService as CampaignModalService } from '../../campaigns/campaigns.service';
import { SendEmailModal } from '../../../shared/modals/send-email/send-email.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-clients',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.scss']
})

export class ClientDetailsComponent implements OnInit, OnDestroy {
  private tabOrder: Array<{ id: number; name: string; visible: boolean }> = [];
  private hasInitializedTabs: boolean = false;

  savedSearchId!: string;
  private loadEvent!: LoadDataFromServer;

  doWhat: IPermission = {} as IPermission;
  leadsPermissions: IPermission = {} as IPermission;
  ordersPermissions: IPermission = {} as IPermission;

  columnsCampaign: Array<any> = [];
  leadsColumns: Array<any> = [];
  orderColumns = [
    { title: 'ID', field: 'numericId', sortable: true, searchable: true },
    { title: 'FROM', field: 'startDate', sortable: true, searchable: true },
    { title: 'TO', field: 'endDate', sortable: true, searchable: true },
    { title: 'AMOUNT', field: 'amount', sortable: true, searchable: true, pipe: 'Currency', pipeArgs: ['USD', 'symbol', '1.0-2'] },
    { title: 'STATUS', field: 'status', sortable: true, searchable: true, type: 'html' },
    { title: 'SUBSCRIPTION_ID', field: 'subscriptionNumericId', sortable: true, searchable: true, anchorLink: true, anchorType: 'subscription', anchorParamsField: 'subscriptionId' },
    { title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, pipe: 'cleanupCampaign' },
    { title: 'GENERATED_ON', field: 'generatedOn', sortable: true, searchable: true, pipe: 'P_AppDateFormat', pipeArgs: ['YYYY-MM-DD HH:mm'] },
  ]

  reportingConfigTableColumns = [
    { title: 'REPORT_TYPE', field: 'reportType' },
    { title: 'IS_ROLLUP', field: 'isRollup' },
    { title: 'PLATFORMS_LABEL', field: 'platforms' },
    { title: 'CAMPAIGNS', field: 'campaigns' },
    { title: 'TO_EMAIL', field: 'toEmail' },
  ];

  reportingConfigTableData = new Array<{ reportingConfig: IReportingConfig, id: string, reportType: string, isRollup: boolean, platforms: string, campaigns: string, toEmail: string }>();

  showTasks: boolean = true;
  showCompletedTasks: boolean = false;
  showOnlyMyTasks: boolean = true;
  isAdmin: boolean = false;
  isExternal: boolean = false;
  isClientOwner: boolean = false;

  private recomputeTabOrder(): void {
    this.tabOrder = [
      { id: 1, name: 'NOTES', visible: (this.isAdmin || !!this.roleOptions?.notes?.canRead) && !this.instance.isAltLayout },
      { id: 2, name: 'CAMPAIGNS', visible: this.isAdmin || !!this.roleOptions?.campaigns?.canRead },
      { id: 3, name: 'TASKS', visible: (this.isAdmin || !!this.roleOptions?.tasks?.canRead) && !this.instance.isAltLayout },
      { id: 4, name: 'TAGS', visible: (this.isAdmin || !!this.roleOptions?.tags?.canRead) && !this.instance.isAltLayout },
      { id: 5, name: 'SUBSCRIPTIONS', visible: (this.isAdmin || !!this.roleOptions?.subscriptions?.canRead) && !this.instance.isAltLayout },
      { id: 6, name: 'ORDERS', visible: (this.isAdmin || !!this.roleOptions?.subscriptions?.canRead) && !this.instance.isAltLayout },
      { id: 7, name: 'EMAIL_REPORTS', visible: (this.isAdmin || !!this.roleOptions?.reports?.canRead) || (this.isAdmin && this.instance.isAltLayout) },
      { id: 8, name: 'LEADS', visible: this.isAdmin || !!this.roleOptions?.campaigns?.canRead },
      { id: 9, name: 'REPORTS', visible: this.isAdmin || !!this.roleOptions?.campaigns?.canRead },
    ];
  }

  isTabVisible(tabId: number): boolean {
    return this.tabOrder.find(t => t.id === tabId)?.visible ?? false;
  }

  // Get the first visible tab ID for auto-selection
  getFirstVisibleTabId(): number {
    return this.tabOrder.find(tab => tab.visible)?.id ?? 2;
  }

  onActiveTabChange(nextTabId: number): void {
    this.loadDataForTab(nextTabId);
  }

  private ensureActiveTabIsVisible(): void {
    if (this.isTabVisible(this.active)) return;
    this.activateTab(this.getFirstVisibleTabId());
  }

  private activateTab(tabId: number): void {
    Promise.resolve().then(() => {
      this.active = tabId;
      this.loadDataForTab(tabId);
    });
  }

  loadDataForTab(tabId: number): void {
    if (!this.clientData?.id) return; // Wait for client data to be loaded
    
    switch (tabId) {
      case 1: // Notes
        if (!this.clientData?.id) {
          return;
        }
        this.appService.fetchAllNotes(this.clientData.id, NOTES_TYPE.Clients);
        break;
      case 2: // Campaigns
        this.loadCampaigns();
        break;
      case 3: // Tasks
        this.loadTasks();
        break;
      case 8: // Leads
        this.filterLeads();
        break;
      case 6: // Orders
        this.loadOrders();
        break;
      case 7: // Email Reports
        this.loadReportingConfigs();
        break;
      case 9: // Reports
        this.loadCampaigns();
        break;
      // Other tabs handle their own data loading
    }
  }

  
  userId: string = '';
  subscriptions = new Array<any>();  
  leadsData = new Array<ILead>();
  ordersData = new Array<any>();

  isTiered: boolean = false;
  tierName: string = '';
  clientTags: Array<ITag> = [];

  get tierBannerClass(): string {
    const name = (this.tierName ?? '').toLowerCase();
    if (name.includes('basic')) return 'tier-banner--basic';
    if (name.includes('premium')) return 'tier-banner--premium';
    if (name.includes('standard')) return 'tier-banner--standard';
    return 'tier-banner--standard';
  }
  
  active: number = 0;
  dataTotalCount: number = 0;
  leadsTotalCount: number = 0;

  public ROLES = ROLES;

  columnsTasks = new Array<IColumn>();
  campaignsData = new Array<ICampaign>();
  completedTasksColumns: Array<IColumn> = []
  tasksData: Array<ITask> = new Array<ITask>();
  completedTasksData: Array<ITask> = new Array<ITask>();
  permTasksData: Array<ITask> = new Array<ITask>();
  reportingConfigData: Array<IReportingConfig> = [];
  public userRoles: Array<number> = [];
  roleOptions: any = {};

  clientData: IClient = {} as IClient;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  checkingOrders: Array<any> = new Array<any>();
  clientId: string = '';

  selectedCampaignId: string | null = null;

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    public uService: UtilityService,
    private router: Router,
    private taskApiService: TasksApiService,
    private tasksService: TasksService,
    private appService: AppService,
    private clientService: ClientsApiService,
    private campaignsService: CampaignsApiService,
    private leadsApi: LeadsApiService,
    private reportsService: ReportsApiService,
    private subscriptionService: SubscriptionApiService,
    private tagService: TagsApiService,
    private ordersApiService: OrdersApiService,
    private dataFeedService: DataFeedService,
    private clientsService: ClientsService,
    private campaignModalService: CampaignModalService,
    public instance: InstanceService,
    private translate: TranslateService) {

      this.userRoles = [...this.uService.getUserRoles()];

        this.columnsTasks.push({ title: 'TITLE', field: 'title', sortable: true, searchable: true } as IColumn);
        this.columnsTasks.push({ title: 'CLIENT', field: 'clientName', sortable: true, searchable: true } as IColumn);
        this.columnsTasks.push({ title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, anchorLink: true, anchorType: 'campaign', anchorParamsField: 'campaignId' } as IColumn);
        this.columnsTasks.push({ title: 'DUE_DATE', field: 'dueDate', sortable: true, pipe: 'P_AppDateFormat', pipeArgs: ['MM/DD/YYYY'] } as IColumn);
        this.columnsTasks.push({ title: 'ASSIGNED_USER', field: 'assignedUserName', sortable: true } as IColumn);

        this.completedTasksColumns.push({ title: 'TITLE', field: 'title', sortable: true, searchable: true } as IColumn);
        this.completedTasksColumns.push({ title: 'CLIENT', field: 'clientName', sortable: true, searchable: true } as IColumn);
        this.completedTasksColumns.push({ title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true, anchorLink: true, anchorType: 'campaign', anchorParamsField: 'campaignId' } as IColumn);
        this.completedTasksColumns.push({ title: 'COMPLETED_ON', field: 'completedOn', sortable: true, pipe: 'P_AppDateFormat', pipeArgs: ['YYYY/MM/DD HH:mm', true] } as IColumn);
        this.completedTasksColumns.push({ title: 'ASSIGNED_USER', field: 'assignedUserName', sortable: true } as IColumn);
  }

  ngOnInit(): void {
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Clients);
    this.leadsPermissions = this.appService.getUserRolesForPage(PAGE_NAMES.Leads);
    this.ordersPermissions = this.appService.getUserRolesForPage(PAGE_NAMES.Orders);

    this.recomputeTabOrder();

    this.columnsCampaign = [
      { title: 'NAME', field: 'name', sortable: true, searchable: true },
      ...(!this.instance.isAltLayout ? [{ title: 'CLIENT', field: 'clientName', sortable: true, searchable: true }] : []),
      { title: 'PLATFORM', field: 'platform', sortable: true, pipe: 'P_CampaignPlatformTitle', searchable: true },
      { title: 'DMS', field: 'dmsName', sortable: true, searchable: true },
      { title: 'STAGE', field: 'stageId', sortable: true, pipe: 'P_CampaignStageTitle', searchable: true },
      ...(!this.instance.isAltLayout ? [{ title: 'ACTIVE_SUBSCRIPTION', field: 'subscriptionActive', pipe: 'P_Boolean', sortable: true, searchable: true }] : []),
    ];

    this.leadsColumns = [
      { title: 'RECEIVED_AT', field: 'createdAt', sortable: true, searchable: true, pipe: 'P_AppDateFormat', pipeArgs: ['MM/DD/YYYY HH:mm', true] },
      ...(!this.instance.isLastNameFirst ? [{ title: 'FIRST_NAME', field: 'firstName', sortable: true, searchable: true }] : [{ title: 'LAST_NAME', field: 'lastName', sortable: true, searchable: true }]),
      ...(!this.instance.isLastNameFirst ? [{ title: 'LAST_NAME', field: 'lastName', sortable: true, searchable: true }] :[{ title: 'FIRST_NAME', field: 'firstName', sortable: true, searchable: true }]),
      { title: 'EMAIL', field: 'email', sortable: true, searchable: true },
      { title: 'PHONE', field: 'phone', sortable: true, searchable: true },
      { title: 'CAMPAIGN', field: 'campaignName', sortable: true, searchable: true },
      { title: 'REFERRAL_SOURCE', field: 'referralSource', sortable: true, searchable: true },
      { title: 'REFERRAL_ID', field: 'referralId', sortable: true, searchable: true },
      { title: 'MEMBER', field: 'isMember', pipe: 'P_Boolean', sortable: true, searchable: true },
    ];

    this.appService.setPageTitle$('CLIENTS');
    this.appService.setRefreshSignal$(PAGE_NAMES.ClientDetails, '');

    let id = this.route.snapshot.paramMap.get('id');
    this.clientId = id!;

    this.appService.getActiveUser$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(u => {
        if (u.id !== undefined) {
          this.userId = u.id;
        }
        this.isClientOwner = (u.clientOwnerOf ?? []).includes(this.clientId);
        this.isExternal = u.type == ROLES_TYPE.External
        var r = getRolesForPage(u.roles, PAGE_NAMES.Clients);
        this.isAdmin = r.isAdmin;
        if (this.isAdmin) {
          this.showOnlyMyTasks = false;
        }
        if (r.options) {
          this.roleOptions = JSON.parse(r.options!);
        }

        this.recomputeTabOrder();

        if (!this.hasInitializedTabs) {
          this.hasInitializedTabs = true;
          this.activateTab(this.getFirstVisibleTabId());
        } else {
          this.ensureActiveTabIsVisible();
        }
      });
    
    if (id) {
      this.clientService.getClientDetails(id)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.clientData = response.data;
          // Load data for the active tab now that client data is available
          this.loadDataForTab(this.active);
        });
      this.tagService.getAssociatedTags(id, 2)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.clientTags = Array.isArray(response?.data) ? (response.data as Array<ITag>) : [];

          const tierTag = this.clientTags.find(t => {
            const name = (t?.name ?? '').toLowerCase();
            const categories = (t?.categories ?? '').toLowerCase();
            return name.includes('tiered pricing') || (categories === 'pricing' && name.includes('tier'));
          });

          this.isTiered = !!tierTag;
          this.tierName = tierTag ? this.extractTierName(tierTag.name) : '';
        });
    }

    const sub = this.appService.getRefreshSignal$(PAGE_NAMES.ClientDetails);
    if (sub !== null) {
      sub.pipe(takeUntil(this.destroyed$))
        .subscribe((r: RefreshSignals) => {
          this.doRefresh(r.id);
        })
    }

    this.configureTasksService();
  }

  loadCampaigns() {
    if (this.clientId) {
      this.campaignsService.getCampaignsByClient(this.clientId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.campaignsData = response.data.map((campaign: any) => {
            if (campaign.stageId === 8) {
              campaign.statusColor = 'gray';
            }
            if (this.instance.isAltLayout && campaign.clientName) {
              campaign.clientName = campaign.clientName.replace('-- ', '');
            }
            return campaign;
          }).sort((a: ICampaign, b: ICampaign) => a.name.localeCompare(b.name));
        });
    }
    // console.log(this.campaignsData);
  }

  onEditClientDetails(): void {
    this.clientsService.openEditClientModal({ id: this.clientId }, {});
  }

  onDeleteClientDetails(): void {
    this.clientsService.deleteClient();
  }

  updateReportView(campaignId: string) {
    this.selectedCampaignId = campaignId;
  }

  loadOrders() {
    this.checkingOrders = [];
    this.ordersApiService.getAllOrders()
      .pipe()
      .subscribe((response: any) => {
        this.ordersData = response.orders;
        this.dataTotalCount = this.ordersData.length;
        this.subscriptionService.getAllSubscriptions(null, this.clientId!)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((response: any) => {
            if (response.subscriptions) {
              this.subscriptions = response.subscriptions.map((x:any) => {x.dms = x.campaigns[0].dms; x.salesrep = x.campaigns[0].salesRep; return x});
              this.subscriptions.forEach((subscription: any) => {
                var orders = this.ordersData.filter((order: any) => order.subscriptionNumericId === subscription.numericId);
                orders.forEach((order: any) => {
                  order.status = order.isPaymentPending ? `<label style="color:orange">${this.translate.instant('PAYMENT_PENDING')}</label>` : (order.paid && order.isActive ? `<label style="color:green">${this.translate.instant('PAID')} ${this.translateRefundText(order.refundText)}</label>` : (order.paid && !order.isActive ? `<label style="color:red">${this.translate.instant('VOIDED')}</label>` : (!order.paid && order.isActive ? `<label style="color:red">${this.translate.instant('NOT_PAID')}</label>` : `<label style="color:red">${this.translate.instant('CANCELED')}</label>`)));
                  order.clientId = subscription.campaigns[0].clientId;
                  this.checkingOrders.push(order);
                });
              });
            }
          });
    });
  }

  private translateRefundText(refundText: any): string {
    const raw = String(refundText ?? '');
    const normalized = raw.toLowerCase();
    if (normalized.includes('fully refunded')) {
      return this.translate.instant('FULLY_REFUNDED_PARENTHESIS');
    }
    if (normalized.includes('partially refunded')) {
      return this.translate.instant('PARTIALLY_REFUNDED_PARENTHESIS');
    }
    return raw;
  }

  filterLeads() {
    this.campaignsService.getCampaignsByClient(this.clientId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.campaignsData = response.data;
        this.campaignsData.forEach((campaign: ICampaign) => {
          this.leadsApi.getAllLeads({ search: campaign.campaignId })
            .pipe(takeUntil(this.destroyed$))
            .subscribe((response: any) => {
              if (response.leads) {
                var tempLeadsData = [...response.leads].filter((x: ILead) => x.campaignId === campaign.id);
                this.leadsData = this.leadsData.concat(tempLeadsData);
                this.leadsTotalCount = this.leadsData.length;
              }
            });
        });
      });
  }

  loadTasksData() {
    let id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.taskApiService.getTasksByClient(id)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.tasksData = [...response.data.filter((x: ITask) => (x.isCompleted === null || x.isCompleted === false) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true))];
          this.completedTasksData = [...response.data.filter((x: ITask) => (x.isCompleted && x.isCompleted === true) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true))];
        });
    }
  }

  loadTasks() {
    let id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.taskApiService.getTasksByClient(id)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.tasksData = [...response.data.filter((x: ITask) => (x.isCompleted === null || x.isCompleted === false) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true))];
          this.permTasksData = [...response.data];
        });
    }
  }

  configureTasksService() {
    this.tasksService.onSave.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.loadTasksData();
        }
      });
    this.tasksService.onDelete.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.loadTasksData();
        }
      });
    this.tasksService.onMarkAsComplete.pipe(takeUntil(this.destroyed$))
      .subscribe((v: any) => {
        if (v) {
          this.loadTasksData();
        }
      });
  }

  doRefresh(id: string) {
    if (id !== "")
      this.clientService.getClientDetails(id)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          this.clientData = response.data;
        });
  }

  onTaskRowClick(evt: any) {
    this.tasksService.openEditTaskModal(evt, this.isAdmin || this.roleOptions.tasks.canEdit, this.isAdmin || this.roleOptions.tasks.canDelete);
  }

  getCampaignRowLink(row: any) {
    return `/pages/campaign-details/${row.id}`;
  }

  getOrderRowLink(row: any) {
    return `/pages/orders/details/${row.id}`;
  }

  getReportingConfigTableData(clientId: string): void {
    this.reportingConfigTableData = [];
    this.reportingConfigData = [];

    if (clientId) {
      this.reportsService
        .getReportingConfigsByClient(clientId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          let configs = new Array<any>();
          this.reportingConfigData = response.data;

          this.reportingConfigData
            .forEach((reportingConfig: any) => {
              let platformsAll = reportingConfig.platforms as Array<string>;
              let distinctPlatforms = platformsAll.filter((v, i, a) => a.indexOf(v) === i);
              let groupedPlatforms = this.groupBy(platformsAll, (c: any) => c);

              let platforms = distinctPlatforms.map(m => `${m} (${groupedPlatforms[m].length})`).join(', \r\n');

              let c = {
                reportingConfig: reportingConfig,
                id: reportingConfig.id /* Need this column as part of table so that when on delete we can access the list of IDs that were selected*/,
                reportType: reportingConfig.reportType,
                isRollup: reportingConfig.isRollup === true ? this.translate.instant('YES') : this.translate.instant('NO'),
                platforms: platforms,
                campaigns: reportingConfig.campaigns.filter((n: any, i: any) => reportingConfig.campaigns.indexOf(n) === i).join(', \r\n'),
                toEmail: reportingConfig.toEmail
              };
              configs.push(c);
            })
          this.reportingConfigTableData = configs;
        });
    }
  }

  loadReportingConfigs() {
    this.reportingConfigTableData = [];
    this.reportingConfigData = [];
    this.loadCampaigns();
    if (this.clientId) {
      this.reportsService
        .getReportingConfigsByClient(this.clientId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          let configs = new Array<any>();
          this.reportingConfigData = response.data;

          this.reportingConfigData
            .forEach((reportingConfig: any) => {
              let platformsAll = reportingConfig.platforms as Array<string>;
              let distinctPlatforms = platformsAll.filter((v, i, a) => a.indexOf(v) === i);
              let groupedPlatforms = this.groupBy(platformsAll, (c: any) => c);

              let platforms = distinctPlatforms.map(m => `${m} (${groupedPlatforms[m].length})`).join(', \r\n');

              let c = {
                reportingConfig: reportingConfig,
                id: reportingConfig.id /* Need this column as part of table so that when on delete we can access the list of IDs that were selected*/,
                reportType: reportingConfig.reportType,
                isRollup: reportingConfig.isRollup === true ? this.translate.instant('YES') : this.translate.instant('NO'),
                platforms: platforms,
                campaigns: reportingConfig.campaigns.filter((n: any, i: any) => reportingConfig.campaigns.indexOf(n) === i).join(', \r\n'),
                toEmail: reportingConfig.toEmail
              };
              configs.push(c);
            })
          this.reportingConfigTableData = configs;
        });
    }
  }

  groupBy(arr: Array<any>, func: { (c: any): any; (arg0: any): any; }) {
    return arr.reduce((r: { [x: string]: any[]; }, v: any, i: any, a: any, k = func(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  }

  addNewReportingConfig() {
    let reportingConfig = {} as IReportingConfig;
    reportingConfig.isRollup = false;
    reportingConfig.client = this.clientData;
    reportingConfig.clientId = this.clientData.id;
    reportingConfig.toEmail = this.clientData.email;

    this.openReportingConfigModal(reportingConfig);
  }

  editReportingConfigRow(evt: any) {
    this.openReportingConfigModal(evt.reportingConfig);
  }

  isReportingConfig(res: Array<string> | IReportingConfig): res is IReportingConfig {
    return (res as IReportingConfig).id !== undefined;
  }

  deleteReportingConfigRows(evt: Array<string> | IReportingConfig) {
    let param: Array<string> = [];

    if (this.isReportingConfig(evt)) {
      param = [(evt as IReportingConfig).id];
    }
    else {
      param = evt as Array<string>;
    }

    this.reportsService.deleteReportingConfig(param)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.getReportingConfigTableData(this.clientData.id);
      });
  }

  openReportingConfigModal(reportingConfig: IReportingConfig) {
    const dialogRef = this.modalService.open(ClientReportingUpdateModalComponent, { size: 'lg' });
    dialogRef.componentInstance.CampaignsData = this.campaignsData;
    dialogRef.componentInstance.ReportingConfig = reportingConfig;

    const dialogSubmitSubscription = dialogRef.componentInstance.oSaveClicked.subscribe((r: any) => {
      this.reportsService.saveReportingConfig(r)
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response: any) => {
          dialogRef.dismiss();
          this.getReportingConfigTableData(this.clientData.id);
        })

      dialogSubmitSubscription.unsubscribe();
    })
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onAddCampaign() {
    const modalRef = this.campaignModalService.openEditCampaignModal({ clientId: this.clientData.id });
    modalRef.closed.subscribe((savedCampaign?: ICampaign) => {
      if (savedCampaign?.id) {
        this.router.navigate(['/pages/campaign-details', savedCampaign.id]);
      }
    });
  }

  onAddTask() {
    this.tasksService.openEditTaskModal({ id: null, clientId: this.clientData.id }, this.isAdmin || this.roleOptions.tasks.canEdit, this.isAdmin || this.roleOptions.tasks.canDelete);
  }

  onDelete(event: any) {
    this.leadsApi.deleteLead(event)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.appService.fetchAllLeads({
          SavedSearchId: this.savedSearchId,
          ...this.loadEvent
        });
      });
  }

  getRowLink(row: any) {
    return `/pages/lead-details/${row.id}`;
  }

  changeShowTasks() {
    if (this.showCompletedTasks) {
      this.showTasks = true;
      this.showCompletedTasks = false;
    }
  }
  
  changeShowCompletedTasks() {
    if (this.showTasks) {
      this.completedTasksData = this.permTasksData.filter((x: ITask) => (x.isCompleted && x.isCompleted === true) && (this.showOnlyMyTasks ? x.assignedUserId.includes(this.userId) : true));
      this.showTasks = false;
      this.showCompletedTasks = true;
    }
  }

  onShowMyTasksChange() {
    this.loadTasksData();
  }

  openSendEmailModal(): void {
    const clientId = this.clientData?.id || this.clientId || this.route.snapshot.paramMap.get('id');
    if (!clientId) {
      return;
    }

    const modalRef = this.modalService.open(SendEmailModal, {
      size: 'xl',
      backdrop: 'static',
    });

    modalRef.componentInstance.iClientId = clientId;
    modalRef.componentInstance.iCampaignId = '';
    modalRef.componentInstance.iType = NOTES_TYPE.Clients;

    void modalRef.result.then((result: any) => {
      if (result?.saved) {
        this.appService.fetchAllNotes(clientId, NOTES_TYPE.Clients);
      }
    }, (): void => undefined);
  }

  openChangeDmsModal() {
    const id = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(DmsChangeFormComponent, { 
      size: 'md',
      backdrop: 'static',
    });
    if (id) {
      modalRef.componentInstance.clientId = id;
    }
    // Call doRefresh(id) if modal is closed with a result (i.e., saved)
    modalRef.result.then((result: any) => {
      if (id) {
        this.doRefresh(id);
      }
    }, () => {}); // ignore dismissals
  }

  openTechRequestModal() {
    const id = this.route.snapshot.paramMap.get('id');
    const modalRef = this.modalService.open(TechRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
    if (id) {
      modalRef.componentInstance.clientId = id;
    }
  }
  openCreativeRequestModal() {
      const id = this.route.snapshot.paramMap.get('id');
      const modalRef = this.modalService.open(CreativeRequestComponent, { 
        size: 'lg',
        backdrop: 'static',
      });
      if (id) {
        modalRef.componentInstance.clientId = id;
      }
    }
  
  openCreateTaskExternalModal() {
    const clientId = this.route.snapshot.paramMap.get('id');
    const userId = this.clientData?.dmsId;
    const modalRef = this.modalService.open(CreateTaskExternalModal, { 
      size: 'md',
      backdrop: 'static',
    });
    if (userId) {
      modalRef.componentInstance.iUserId = userId;
    }
    if (clientId) {
      modalRef.componentInstance.iClientId = clientId;
    }
  }

  private extractTierName(tagName: string): string {
    if (!tagName) return '';

    // Expected examples:
    // - "Tiered Pricing | Standard Tier"
    // - "Tiered Pricing|Premium Tier"
    // - "Tiered Pricing - Standard Tier"
    const partsPipe = tagName.split('|').map(p => p.trim()).filter(Boolean);
    if (partsPipe.length >= 2) {
      return partsPipe[1];
    }

    const lower = tagName.toLowerCase();
    const idx = lower.indexOf('tiered pricing');
    if (idx >= 0) {
      const after = tagName.slice(idx + 'tiered pricing'.length).replace(/^\s*[-:]\s*/, '').trim();
      return after || tagName;
    }

    return tagName;
  }
}
